import { t } from "i18next";
import { Table } from "../../tables/components/Table";
import { TableCell } from "../../tables/components/TableCell";
import WingmanAdminTableCtrls from "./WingmanAdminTableCtrls";
import WingmanAdminRoleSelect from "./WingmanAdminRoleSelect";
import WingmanAdminBrandSelect from "./WingmanAdminBrandSelect";
import { WingmanAdminDocument, WingmanAdminDocumentIndentifier } from "../models/WingmanAdminDocument";
import { useTableRegister } from "../../tables/hooks/useTableRegister";
import WingmanAdminViewableSelect from "./WingmanAdminViewableSelect";
import WingmanAdminUploadStatusCell from "./WingmanAdminUploadStatusCell";

type WingmanAdminUploadTableProps = {
  beginImport: boolean,
  handleDelete: (payload: WingmanAdminDocumentIndentifier) => void,
  handleReplace: (payload: WingmanAdminDocumentIndentifier) => void,
  uploadDocuments: WingmanAdminDocument[],
  authorizedBrands: string[],
  handleViewableFlag: (payload: WingmanAdminDocument) => void,
  handleSelectedRoles: (payload: WingmanAdminDocument) => void,
  handleSelectedBrands: (payload: WingmanAdminDocument) => void,
  handleClear: (payload: WingmanAdminDocumentIndentifier) => void,
}

const WingmanAdminUploadTable = ({ uploadDocuments, beginImport, handleSelectedBrands, handleSelectedRoles, handleViewableFlag, handleDelete, handleReplace, handleClear, authorizedBrands }: WingmanAdminUploadTableProps) => {
  const register = useTableRegister<WingmanAdminDocument>();

  return (
    <Table autoResetPageIndex={false} data={uploadDocuments} className="text-xs overflow-x-auto" key={beginImport.toString()}>
      {!beginImport &&
        <WingmanAdminUploadStatusCell
          id="status"
          header={t`Status`}
          {...register(s => s.uploadStatus)}
        />
      }
      <TableCell
        id="filename"
        header={t`File Name`}
        {...register(s => s.Filename)}
        sortDescFirst={false}
      />
      <TableCell
        id="Brand"
        header={t`Brand`}
        {...register(m => (
          <WingmanAdminBrandSelect
            id={m.id}
            uploadStatus={m.uploadStatus ?? "Complete"}
            filename={m.Filename ?? ""}
            brands={Array.isArray(m.Brand) ? m.Brand : []}
            handleSelectedBrands={handleSelectedBrands}
            authorizedBrands={authorizedBrands} />
        ))}
        enableSorting={false}
      />
      <TableCell
        id="Role"
        header={t`Role`}
        {...register(m => (
          <WingmanAdminRoleSelect
            id={m.id}
            fileName={m.Filename ?? ""}
            authorizedBrands={authorizedBrands}
            handleSelectedRoles={handleSelectedRoles}
            uploadStatus={m.uploadStatus ?? "Complete"}
            roles={Array.isArray(m.Role) ? m.Role : []}
            brands={Array.isArray(m.Brand) ? m.Brand : []}
          />
        ))}
        enableSorting={false}
      />
      <TableCell
        id="Viewable"
        header={t`Viewable`}
        {...register(m => (
          <WingmanAdminViewableSelect
            id={m.id}
            viewableFlag={m.Viewable}
            fileName={m.Filename ?? ""}
            authorizedBrands={authorizedBrands}
            handleViewableFlag={handleViewableFlag}
            uploadStatus={m.uploadStatus ?? "Complete"}
            brands={Array.isArray(m.Brand) ? m.Brand : []}
          />
        ))}
        enableSorting={false}
      />
      <TableCell
        id="createdAt"
        header={t`Created At`}
        {...register(s => s.created_date)}
        sortDescFirst={false}
      />
      <TableCell
        id="updatedAt"
        header={t`Updated At`}
        {...register(s => s.updated_date)}
        sortDescFirst={false}
      />
      <TableCell
        id="UpdatedBy"
        header={t`Updated By`}
        {...register(s => s.Updated_by || "")}
        sortDescFirst={false}
      />
      <TableCell
        id="Ctrls"
        header={t`Controls`}
        {...register(m => (
          <WingmanAdminTableCtrls
            id={m.id}
            handleClear={handleClear}
            fileName={m.Filename ?? ""}
            handleDelete={handleDelete}
            handleReplace={handleReplace}
            authorizedBrands={authorizedBrands}
            uploadStatus={m.uploadStatus ?? "Complete"}
            brands={Array.isArray(m.Brand) ? m.Brand : []}
          />
        ))}
        enableSorting={false}
      />
    </Table>
  );
};

export default WingmanAdminUploadTable;

